import { JsonPath } from "../types/json-path";

export function replaceVars(json: JsonPath, value: string): string {
  let replacedValue = value.replaceAll("${customer.phone}", json.customer.phone);
  replacedValue = replacedValue.replaceAll("${customer.email}", json.customer.email);
  return replacedValue;
}